<template>
  <div class>
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>
        <v-icon class="icon">fa-plus</v-icon>Add Partner
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small @click="closePanel" :color="this.$gf.headerColor()">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-form>
            <v-text-field
              :error-messages="messages.first_name"
              v-model="partner.first_name"
              label="First Name"
              type="text"
            ></v-text-field>
            <v-text-field
              :error-messages="messages.last_name"
              v-model="partner.last_name"
              label="Last Name"
              type="text"
            ></v-text-field>
            <v-text-field
              :error-messages="messages.email"
              v-model="partner.email"
              label="Email"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model="partner.company"
              :error-messages="messages.company"
              label="Organisation"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model="partner.phone"
              :error-messages="messages.phone"
              label="Phone"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model="partner.address"
              :error-messages="messages.address"
              label="Address Line 1"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model="partner.address2"
              :error-messages="messages.address2"
              label="Address Line 2"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model="partner.city"
              :error-messages="messages.city"
              label="City"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model="partner.postcode"
              :error-messages="messages.postcode"
              label="Postcode"
              type="text"
            ></v-text-field>
            <v-select
              v-if="$globalConfig.APP_NAME == 'senso'"
              v-model="partner.partner_level"
              :items="partnerLevelList"
              item-text="name"
              item-value="id"
              label="Account Level"
              hint="Choose Partner Level"
              :error-messages="messages.partner_level"
              class="mt-4"
              @change="showCompanyList()"
              attach
            ></v-select>
            <v-select v-show="isLevelTier2"
              v-model="partner.referred_by"
              :items="partnerCompanyList"
              item-text="company_name"
              item-value="id"
              label="Referred By"
              hint="Choose Referred By"
              class="mt-4"
              attach
            ></v-select>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer height="68">
      <v-flex text-right>
        <v-btn color="primary" class="mr-1" @click="closePanel">Cancel</v-btn>
         <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn color="primary" v-else @click="addPartner">Add Partner</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import partnerAPI from "@/api/partner.js";

export default {
  name: "AddPartner",
  props: {
    params: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      partner: {},
      messages: {},
      partnerLevelList: [
        { name: "Level 1", id: 1 },
        { name: "Level 2", id: 2 }
      ],
      partnerCompanyList: [],
      isLevelTier2: false,
      successMessage: "Partner Successfully Added.",
      errorMessage:
        "Oops, something went wrong! Please check information is correct.",
      loading: false  
    };
  },
  mounted() {
    this.getPartnerCompanyList();
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
    },
    addPartner() {
      this.loading = true;
      partnerAPI
        .createPartner(this.partner)
        .then(() => {
          this.closePanel();
          EventBus.$emit("PARTNER_UPDATED", this.params);
          this.$snotify.success(this.successMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
            this.loading = false;
        })
        .catch(err => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
            this.loading = false;
        });
    },
    
    showCompanyList() {
      if(this.partner.partner_level==2) {
        this.isLevelTier2 = true
        this.partner.commission=15
      } else {
        this.isLevelTier2 = false;
        this.partner.commission=25
      }
    },
    getPartnerCompanyList() {
      partnerAPI.getPartnerByTier(1).then(response => {
        this.partnerCompanyList = response.data.data;
      });
    }
  }
};
</script>
